import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CompanyRelationshipType, PageResponseV2 } from '../models/empresa.model';

@Injectable({
  providedIn: 'root'
})
export class CompanyRelationshipTypeApiService {
  private readonly apiUrl = `${environment.apiUrl}api/company-relationship-types`;

  constructor(private http: HttpClient) { }

  // GET /api/company-relationship-types - List all relationship types (paginated)
  getAll(params?: { page?: number; size?: number }): Observable<PageResponseV2<CompanyRelationshipType>> {
    let queryParams = new HttpParams();
    if (params?.page != null) queryParams = queryParams.set('page', params.page);
    if (params?.size != null) queryParams = queryParams.set('size', params.size);
    return this.http.get<PageResponseV2<CompanyRelationshipType>>(this.apiUrl, { params: queryParams });
  }

  // GET /api/company-relationship-types/{id} - Get by ID
  getById(id: number): Observable<CompanyRelationshipType> {
    return this.http.get<CompanyRelationshipType>(`${this.apiUrl}/${id}`);
  }

  // POST /api/company-relationship-types - Create (requires Sales Rep or higher)
  create(relationshipType: Omit<CompanyRelationshipType, 'id'>): Observable<CompanyRelationshipType> {
    return this.http.post<CompanyRelationshipType>(this.apiUrl, relationshipType);
  }

  // PUT /api/company-relationship-types/{id} - Update (requires Sales Rep or higher)
  update(id: number, relationshipType: Omit<CompanyRelationshipType, 'id'>): Observable<CompanyRelationshipType> {
    return this.http.put<CompanyRelationshipType>(`${this.apiUrl}/${id}`, relationshipType);
  }

  // DELETE /api/company-relationship-types/{id} - Delete (requires Admin or higher)
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
